/** Security-key registration: options, the browser's create(), then verify. */

import type { AccountSecurityApi, StepUpProof } from '@dealr/api-account';
import { attestationToJson, creationOptionsFromJson } from '@dealr/core-account';
import type { WebAuthnPort } from './ports';
import { SecondFactorError, cancelOr } from './secondFactor';

export async function registerSecurityKey(
  api: Pick<AccountSecurityApi, 'webauthnRegisterOptions' | 'webauthnRegisterVerify'>,
  webauthn: WebAuthnPort | null,
  label?: string,
  stepUp?: StepUpProof,
): Promise<string> {
  if (!webauthn) throw new SecondFactorError('This browser does not support security keys or passkeys.');
  const options = await api.webauthnRegisterOptions(stepUp);
  let credential;
  try {
    credential = await webauthn.create(creationOptionsFromJson(options.publicKey));
  } catch (error) {
    throw cancelOr(error);
  }
  if (!credential) throw new SecondFactorError('No security key response was received.', true);
  const body: { credential: ReturnType<typeof attestationToJson>; label?: string } = { credential: attestationToJson(credential) };
  if (label && label.trim()) body.label = label.trim();
  const result = await api.webauthnRegisterVerify(body);
  return result.method_uuid;
}
